module.exports = __webpack_public_path__ + "img/logo-claim-vert-neg.35b757ae.png";